module.exports = __webpack_public_path__ + "img/ico_cancelamento-planos.46297f13.svg";